import { render, staticRenderFns } from "./ClinicProviderProducts.vue?vue&type=template&id=7cda787c"
import script from "./ClinicProviderProducts.vue?vue&type=script&lang=js"
export * from "./ClinicProviderProducts.vue?vue&type=script&lang=js"
import style0 from "./ClinicProviderProducts.vue?vue&type=style&index=0&id=7cda787c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports